<template>
  <validation-observer ref="budgetFormRef" novalidate tag="form">
    <callout
      border-color="green"
      class="mb-4 shadow custom-callout-budget"
      :has-toggle="false"
    >
      <div class="row">
        <div class="col-md-12">
          <icon-view
            icon="fas fa-file-plus"
            icon-background="#fff"
            icon-color="#3dbd8c"
            icon-size="14px"
            title="Procesar Carga"
          />
        </div>
      </div>
      <div class="row ml-4 pl-1 my-3">
        <div class="col-md-4 col-sm-12">
          <div class="data-name">Año Académico:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.academicYear"
              :clearable="false"
              custom-error-msg="Favor de seleccionar Año Académico."
              :error="errors[0]"
              fieldkey="id"
              fieldname="description"
              :options="academicYears"
              placeholder="Seleccione"
              @input="loadMessageForBatchLoad()"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="data-name">Servicio:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.service"
              class="w-100"
              :clearable="false"
              custom-error-msg="Favor de seleccionar el Servicio."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="services"
              placeholder="Seleccione"
              @input="loadMessageForBatchLoad()"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 text-right mt-3 pr-5 pt-1">
          <action-button
            i="fas fa-times-circle"
            variant="outline-danger mr-3"
            @click="onCancel"
          >
            Cancelar
          </action-button>
          <action-button i="fas fa-repeat" variant="success" @click="onSave">
            Procesar
          </action-button>
        </div>
      </div>
      <div class="row ml-4 mr-3 pl-1">
        <div class="col-md-12">
          <error v-if="message != null" is-alert-mode :message="message" />
        </div>
      </div>
    </callout>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Callout from '@/shared/components/Callout/View';
import { ActionButton, CustomDropDown, Error } from '@/components/common';
import IconView from '@/views/provider/billingHistory/components/IconView';
import alertMixin from '@/mixins/alert.mixin';
import { getBatchLoadControlNextProcessPeriod as _getBatchLoadControlNextProcessPeriod } from '@/modules/shared/loadprocess.api.js';

export default {
  name: 'CreateProcess',
  components: {
    ValidationObserver,
    ValidationProvider,
    Callout,
    ActionButton,
    CustomDropDown,
    IconView,
    Error,
  },
  mixins: [alertMixin],
  props: {
    academicYears: {
      type: Array,
      default: () => [],
    },
    services: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      model: {
        academicYear: null,
        service: null,
        monthNumber: null,
      },
      message: null,
    };
  },
  methods: {
    onCancel() {
      this.$emit('on-cancel');
    },
    async onSave() {
      const isValid = await this.$refs.budgetFormRef.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor de documentar todos los campos requeridos para continuar con la acción.',
          'error'
        );
        return;
      }
      this.$emit('on-save', this.model);
    },
    async loadMessageForBatchLoad() {
      const isValid =
        this.model.academicYear != null && this.model.service != null;

      if (isValid) {
        _getBatchLoadControlNextProcessPeriod(
          this.model.academicYear.id,
          this.model.service.id
        )
          .then(async ({ data }) => {
            this.model.monthNumber = data.monthNumber;
            this.message =
              'El próximo periodo identificado a procesar es: ' +
              data.monthDesc +
              ' - ' +
              data.year +
              '. Si está de acuerdo presione Procesar.';
          })
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
            this.message = null;
            this.model.service = null;
            this.model.academicYear = null;
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-callout-budget {
  ::v-deep .callout-container {
    border-left-width: 5px;
  }
}
</style>
